export const fromValues = (property: string, defaultVal?: any) => (valuesObj) =>
  valuesObj[property] ?? defaultVal;

export const clx = (...classes) => classes.filter((a) => a).join(' ');
